import React, { useState, useEffect, useContext, useRef } from "react";
import Icon from "../../Icons/SmallIcon/SmallIcon";
import SwitchButton from "../SwitchButton/SwitchButton";
import { Button } from "../../StyledComponents/StyledComponents";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import { useDispatch, useSelector } from "react-redux";

const ResumeButton = (props) => {
  const [rand, setRand] = useState("");

  useEffect(() => {
    const min = 1;
    const max = 100;
    setRand(min + Math.random() * (max - min));
  }, []);
  const { resume } = useSelector((state) => state.resumeGetById);
  return (
    <>
      {props && props.size ? (
        <>
          <div>
            <Button {...props} id={rand} onClick={""} type="button">
              <div className="d-flex justify-content-between">
                <div className="d-flex">
                  <div>
                    {props.left_icon && (
                      <div className="pt-2" style={{ paddingLeft: "10px" }}>
                        <Icon src={props.src} left medium={props.medium} />
                      </div>
                    )}
                  </div>
                  <div className="pt-2">{props.title}</div>
                </div>

                <div>
                  {props.right_icon && <Icon src={props.src} right />}
                  {props.switch && (
                    <SwitchButton id={props.id} checked={props.checked} />
                  )}
                  {props.size && (
                    <div className="p-0 mr-2">
                      <BootstrapSwitchButton
                        checked={resume && resume.isLetter ? true : false}
                        onstyle="outline-success"
                        offstyle="outline-success"
                        width={77}
                        onlabel="Letter"
                        offlabel="A4"
                        onChange={(checked) =>
                          props.onClick(checked, props && props.type)
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            </Button>
          </div>
        </>
      ) : (
        <>
          <div style={{
            display: props.block ? props.block : "",
          }}>
            <Button {...props} id={rand} onClick={props.onClick} type="button">
              <div className="d-flex">
                {props.left_icon && (
                  <div>
                    <Icon src={props.src} left medium={props.medium} />
                  </div>
                )}

                <div>{props.title}</div>
                <div>
                  {props.right_icon && <Icon src={props.src} right />}
                  {props.switch && (
                    <SwitchButton id={props.id} checked={props.checked} />
                  )}
                </div>
              </div>
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default ResumeButton;
